var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.84 10.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_21",
    "data-name": "Rectangle 3 copy 21",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.76,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_2",
    "data-name": "Rectangle 3 copy 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.32,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_3",
    "data-name": "Rectangle 3 copy 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.88,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_4",
    "data-name": "Rectangle 3 copy 4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.44,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_5",
    "data-name": "Rectangle 3 copy 5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_12",
    "data-name": "Rectangle 3 copy 12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_12-2",
    "data-name": "Rectangle 3 copy 12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.32,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_12-3",
    "data-name": "Rectangle 3 copy 12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_12-4",
    "data-name": "Rectangle 3 copy 12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.44,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_12-5",
    "data-name": "Rectangle 3 copy 12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_22",
    "data-name": "Rectangle 3 copy 22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 8.64,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_23",
    "data-name": "Rectangle 3 copy 23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.64,
    width: 14.4,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_6",
    "data-name": "Rectangle 3 copy 6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4.32,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_7",
    "data-name": "Rectangle 3 copy 7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_8",
    "data-name": "Rectangle 3 copy 8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.44,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_9",
    "data-name": "Rectangle 3 copy 9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.88,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_10",
    "data-name": "Rectangle 3 copy 10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.32,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_11",
    "data-name": "Rectangle 3 copy 11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.76,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy",
    "data-name": "Rectangle 3 copy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.64,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_16",
    "data-name": "Rectangle 3 copy 16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.64,
    y: 4.32,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_17",
    "data-name": "Rectangle 3 copy 17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.64,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_19",
    "data-name": "Rectangle 3 copy 19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_19-2",
    "data-name": "Rectangle 3 copy 19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 4.32,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_19-3",
    "data-name": "Rectangle 3 copy 19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_13",
    "data-name": "Rectangle 3 copy 13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.64,
    y: 1.44,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_14",
    "data-name": "Rectangle 3 copy 14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.64,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_20",
    "data-name": "Rectangle 3 copy 20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 2.88,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_20-2",
    "data-name": "Rectangle 3 copy 20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 4.32,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_20-3",
    "data-name": "Rectangle 3 copy 20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 5.76,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_20-4",
    "data-name": "Rectangle 3 copy 20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 1.44,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_20-5",
    "data-name": "Rectangle 3 copy 20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_15",
    "data-name": "Rectangle 3 copy 15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.08,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_18",
    "data-name": "Rectangle 3 copy 18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    width: 1.44,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3_copy_21-2",
    "data-name": "Rectangle 3 copy 21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.96,
    width: 1.44,
    height: 1.44
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmLogo);
export default __webpack_public_path__ + "static/media/EM Logo.517ee6f24c016a5eaaa61e1e645cf09a.svg";
export { ForwardRef as ReactComponent };